import React, { Suspense } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
// Lazy load the actual map component
const MapControlImpl = React.lazy(() => import('./MapControl'));
const LazyMapControl = () => {
    return (React.createElement(Suspense, { fallback: React.createElement(Box, { id: "map", sx: {
                height: '500px',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f0f0f0',
                borderRadius: '4px'
            } },
            React.createElement(Box, { sx: { textAlign: 'center' } },
                React.createElement(CircularProgress, { size: 40 }),
                React.createElement(Typography, { variant: "body2", sx: { mt: 2 } }, "Loading map..."))) },
        React.createElement(MapControlImpl, null)));
};
export default LazyMapControl;
